var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var retrieveUserAnswers = function (_a) {
    var userAnswer = _a.userAnswer, userAnswers = _a.userAnswers, indexOfPreviouslyAnsweredQuestion = _a.indexOfPreviouslyAnsweredQuestion;
    var userAnswersCopy = __spreadArray([], userAnswers, true);
    userAnswersCopy[indexOfPreviouslyAnsweredQuestion] = userAnswer;
    return userAnswersCopy.slice(0, indexOfPreviouslyAnsweredQuestion + 1);
};
export default retrieveUserAnswers;
//# sourceMappingURL=helpers.js.map